<template>
    <div class="container">
        <v-treeview class="sitamenue" selectable :items="items" @input="onInput_buildQuery" return-object />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Reportsmenu',

    /* >>> *************************************************************** / /* Components */
    components: {}, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: () => ({
        selectionType: 'leaf',
        selections: [],
        query: '',
        items: [
            {
                id: 1,
                name: 'Schedule:',
                children: [
                    { id: 2, name: 'Departure Date', type: 'flight', query: 'departureDate' },
                    {
                        id: 101,
                        name: 'Arrival Date',
                        type: 'a41_flight_segments',
                        query: 'a41_flight_segments { arr_schedule_time }',
                    },
                    { id: 3, name: 'FlightNumber', type: 'flight', query: 'flightNumber' },
                    {
                        id: 13,
                        name: 'ATC Call Sign',
                        type: 'flightInfos',
                        query: 'flightInfos { atcCallsign }',
                    },
                    {
                        id: 4,
                        name: 'Aircraft Reg',
                        type: 'flightInfos',
                        query: 'flightInfos { aircraftId }',
                    },
                    {
                        id: 11,
                        name: 'Aircraft Type',
                        type: 'flightInfos',
                        query: 'flightInfos { acType }',
                    },
                    {
                        id: 6,
                        name: 'Departure Time',
                        type: 'flightInfos',
                        query: 'flightInfos { departureDatetime }',
                    },
                    {
                        id: 7,
                        name: 'Arrival Time',
                        type: 'a41_flight_segments',
                        query: 'a41_flight_segments { arr_schedule_time }',
                    },
                    {
                        id: 5,
                        name: 'Departure Airport',
                        type: 'flight',
                        query: 'departureAirport',
                    },
                    {
                        id: 8,
                        name: 'Arrival Airport',
                        type: 'flightInfos',
                        query: 'flightInfos { destinationAirport }',
                    },
                    {
                        id: 10,
                        name: 'Departure Airport ICAO',
                        type: 'flight',
                        query: 'departureAirportICAO',
                    },
                    {
                        id: 12,
                        name: 'Destiantion Airport ICAO',
                        type: 'flightInfos',
                        query: 'flightInfos { destinationAirportICAO }',
                    },
                    { id: 14, name: 'Natur Of Flight', disabled: !0, query: '' },
                ],
            },
            {
                id: 59,
                name: 'Times:',
                children: [
                    {
                        id: 15,
                        name: 'Offblock Time',
                        type: 'logs',
                        query: 'logs { offBlock { time { value } } }',
                    },
                    { id: 16, name: 'ATOT', type: 'logs', query: 'logs { ATOT }' },
                    {
                        id: 170,
                        name: 'TakeOff Time',
                        type: 'logs',
                        query: 'logs { takeOff { departureDate } }',
                    },
                    {
                        id: 17,
                        name: 'Landing Time',
                        type: 'logs',
                        query: 'logs { landing { arrivalDate } }',
                    },
                    {
                        id: 18,
                        name: 'Onblock Time',
                        type: 'logs',
                        query: 'logs { onBlock { time { value } } }',
                    },
                    {
                        id: 20,
                        name: 'Block Time',
                        type: 'logs',
                        query: 'logs { flightInfo { fullTripTime } }',
                    },
                    {
                        id: 19,
                        name: 'Flight Time',
                        type: 'logs',
                        query: 'logs { calculated { flightTime } }',
                    },
                ],
            },
            {
                id: 21,
                name: 'Fuel:',
                children: [
                    {
                        id: 26,
                        name: 'Fuel Off Block [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"block"',
                        query: 'reviewed',
                    },
                    {
                        id: 53,
                        name: 'Fuel On Block [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"fuelAtDestination"',
                        query: 'reviewed',
                    },
                    {
                        id: 52,
                        name: 'Fuel Used [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"trip"',
                        query: 'reviewed',
                    },
                    {
                        id: 23,
                        name: 'Fuel Contingency [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"contingency"',
                        query: 'reviewed',
                    },
                    {
                        id: 22,
                        name: 'Fuel Taxi [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"taxi"',
                        query: 'reviewed',
                    },
                    {
                        id: 27,
                        name: 'Fuel Discretionary [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"discretionary"',
                        query: 'reviewed',
                    },
                    {
                        id: 29,
                        name: 'Fuel Alternate [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"alternate"',
                        query: 'reviewed',
                    },
                    {
                        id: 28,
                        name: 'Fuel minTof [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"minTof"',
                        query: 'reviewed',
                    },
                    {
                        id: 25,
                        name: 'Final Reserve [kg]',
                        type: 'logs_weightAndFuel_fuel',
                        category: '"finaReserve"',
                        query: 'reviewed',
                    },
                    {
                        id: 30,
                        name: 'OFP Fuel On Block [kg]',
                        type: 'logs',
                        query: 'logs { onBlock { totalBurnedFuel { value } } }',
                    },
                    {
                        id: 31,
                        name: 'OFP Fuel Used [kg]',
                        type: 'logs',
                        query: 'logs { onBlock { totalRemainingFuel { value } } }',
                    },
                    {
                        id: 32,
                        name: 'Uplift',
                        children: [
                            {
                                id: 34,
                                name: 'FOB before Uplift [kg]',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { fobBeforeRefueling } } } }',
                            },
                            {
                                id: 38,
                                name: 'Uplift [kg]',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { uplifts { uplift } } } } }',
                            },
                            {
                                id: 100,
                                name: 'Uplift [ltr]',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { uplifts { calculated { upliftInLitre } } } } } }',
                            },
                            {
                                id: 37,
                                name: 'Density',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { uplifts { density } } } } }',
                            },
                            {
                                id: 33,
                                name: 'Provider Code',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { code } } } }',
                            },
                            {
                                id: 36,
                                name: 'Apu Consumption [kg]',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { apuConsumption } } } }',
                            },
                            {
                                id: 35,
                                name: 'OFP Fuel Off Block [kg]',
                                type: 'logs',
                                query: 'logs { weightAndFuel { uplift { suppliers { fuelOnBoard } } } }',
                            },
                        ],
                    },
                    {
                        id: 39,
                        name: 'Extra Fuel Reasons',
                        children: [
                            {
                                id: 40,
                                name: 'Extra Fuel [kg]',
                                type: 'logs',
                                query: 'logs { extraFuelReasons { value } }',
                            },
                            {
                                id: 41,
                                name: 'Extra Fuel Code',
                                type: 'logs',
                                query: 'logs { extraFuelReasons { code } }',
                            },
                            {
                                id: 42,
                                name: 'Extra Fuel Comment',
                                type: 'logs',
                                query: 'logs { extraFuelReasons { comment } }',
                            },
                        ],
                    },
                    {
                        id: 43,
                        name: 'Overburn Fuel Reasons',
                        children: [
                            {
                                id: 44,
                                name: 'Overburne Fuel [kg]',
                                type: 'logs',
                                query: 'logs { overburnFuelReasons { value } }',
                            },
                            {
                                id: 45,
                                name: 'Overburne Fuel Code',
                                type: 'logs',
                                query: 'logs { overburnFuelReasons { code } }',
                            },
                            {
                                id: 46,
                                name: 'Overburne Fuel Comment',
                                type: 'logs',
                                query: 'logs { overburnFuelReasons { comment } }',
                            },
                        ],
                    },
                ],
            },
            {
                id: 47,
                name: 'Weight:',
                children: [
                    {
                        id: 48,
                        name: 'Weight DOW [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"dow"',
                        query: 'reviewed',
                    },
                    {
                        id: 51,
                        name: 'Weight ZFW [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"zfw"',
                        query: 'reviewed',
                    },
                    {
                        id: 102,
                        name: 'Weight Payload [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"payload"',
                        query: 'reviewed',
                    },
                    {
                        id: 50,
                        name: 'Weight TOW [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"tow"',
                        query: 'reviewed',
                    },
                    {
                        id: 49,
                        name: 'Weight LAW [kg]',
                        type: 'logs_weightAndFuel_weight',
                        category: '"law "',
                        query: 'reviewed',
                    },
                ],
            },
            { id: 54, name: 'PAX:', disabled: !0 },
            {
                id: 55,
                name: 'Crew',
                children: [
                    {
                        id: 58,
                        name: 'Landing Pilot',
                        type: 'logs',
                        query: 'logs { landing { pilotFlying } }',
                    },
                    {
                        id: 56,
                        name: 'Crew Name',
                        type: 'logs',
                        query: 'logs { crew { name } }',
                    },
                    {
                        id: 57,
                        name: 'Crew Role',
                        type: 'logs',
                        query: 'logs { crew { role } }',
                    },
                ],
            },
        ],
    }), // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {
        ...mapGetters([]),
    }, // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Watch */
    watch: {}, // eof watch{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
     * Lifecyclehook::created
     *
     * Desc:
     * Note:
     *
     */
    created: function () {
        const me = this;

        me.$toc('>>> views/shared/components/core/components/SitaMenue.vue >>> created');
    }, // eo function created()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {
        ...mapActions([]),

        onInput_buildQuery: function (items) {
            const me = this;
            me.$toc('>>> views/shared/components/core/components/SitaMenue.vue >>> onInput_buildQuery');
            this.query = items.map((item) => {
                if (item.type === 'logs_weightAndFuel_fuel') {
                    let categories = items
                        .filter((item) => item.type === 'logs_weightAndFuel_fuel')
                        .map((fuel) => fuel.category)
                        .join(', ');
                    return `logs { weightAndFuel { fuel (category: [${categories}]) { reviewed } } }`;
                }
                if (item.type === 'logs_weightAndFuel_weight') {
                    let categories = items
                        .filter((item) => item.type === 'logs_weightAndFuel_weight')
                        .map((weight) => weight.category)
                        .join(', ');
                    return `logs { weightAndFuel { weight (category: [${categories}]) { reviewed } } }`;
                }
                return item.query;
            });
        },
    }, // eof methods()
    /* <<< ****************************************************************/
};
</script>

<style scoped>
.sitamenue >>> .v-treeview-node:nth-child(2n + 1) {
    background: rgb(255, 255, 255);
}
.container {
    height: 50%;
}
</style>
